import { IReview, IReviewVideo } from '../components/types'
import { reviews_elements_edges_node } from '../__generated__/reviews'

import {
  getCatalogElementUrl,
  getPropElementByCode,
  getPropFilesByCode,
} from './gql'
import { getPropByCode } from './gql'
import { reviewById_element } from '../__generated__/reviewById'

export const createReview = (
  element: reviews_elements_edges_node | reviewById_element,
): IReview => {
  const target = getPropElementByCode(
    element?.propertyValuesRelation,
    'ELEMENT',
  )
  const rate = +getPropByCode(element.propertyValues, 'RATE')
  const reply = getPropByCode(element.propertyValues, 'REPLY')
  const images = getPropFilesByCode(
    element?.propertyValuesRelation,
    'PHOTOS',
  ) as {
    id: string
    url: string
  }[]

  const videos = getPropFilesByCode(
    element?.propertyValuesRelation,
    'VIDEOS',
  ) as IReviewVideo[]

  return {
    id: element.id,
    bx_id: element.bx_id,
    name: element.name,
    rate,
    text: element.detailText,
    date: element.createdAt,
    product: {
      name: target?.name,
      href: target?.active ? getCatalogElementUrl(target) : null,
    },
    images,
    videos,
    reply,
  }
}
